export default {
    url: '/notifications',
    template: '<notifications/>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/notifications/index.js